import {financeiro_content_routes } from './resultado';
import {ContentRoute} from "../../models/Route";
import enumDescription from "../../services/enumDescription";

const routes: Array<ContentRoute> = financeiro_content_routes

export enum SituacaoTypes {
    EM_ABERTO = 1,
    FECHADO   = 2,
    FATURADO  = 3,
    PAGO  = 4,
    CANCELADO = 5,
}

export enum SituacaoFaturaTypes {
    FECHADO = 1,
    FATURADO = 2,
    PAGO = 3,
    CANCELADO = 4,
    ENVIADO = 5,
    SITUACAO_EM_PROCESSAMENTO =6,
    PAGO_PARCIAL = 7
}

export enum SituacaoFaturaDocumentoTypes {
    SITUACAO_PENDENTE = 1,
    SITUACAO_SINCRONIZADO = 2,
    SITUACAO_CANCELADO = 3,
    SITUACAO_PRONTO_ENVIO = 4,
    SITUACAO_LIQUIDADO  = 5,
    SITUACAO_LIQUIDADO_ERRO_ENVIO  = 6,
}
export enum TipoFaturaDocTypes {
    BOLETO= 1,
    NOTA_FISCAL  = 2,
}

export enum TipoOrigem {
    GERADO_AUTOMATICAMENTE = 1,
    GERADO_MANUALMENTE  = 2,
}

export const SituacaoList = new enumDescription(  [
    {   value: SituacaoTypes.EM_ABERTO, description: 'Aberto'},
    {   value: SituacaoTypes.FECHADO, description: 'Fechado'},
    {   value: SituacaoTypes.FATURADO, description: 'Faturado'},
    {   value: SituacaoTypes.PAGO, description: 'Pago'},
    {   value: SituacaoTypes.CANCELADO, description: 'Cancelado'}
]);

export const SituacaoFaturaList = new enumDescription(  [
    {   value: SituacaoFaturaTypes.SITUACAO_EM_PROCESSAMENTO, description: 'Em Aberto'},
    {   value: SituacaoFaturaTypes.FECHADO, description: 'Fechado'},
    {   value: SituacaoFaturaTypes.FATURADO, description: 'Faturado'},
    {   value: SituacaoFaturaTypes.ENVIADO, description: 'Faturado e Enviado'},
    {   value: SituacaoFaturaTypes.PAGO, description: 'Pago'},
    {   value: SituacaoFaturaTypes.CANCELADO, description: 'Cancelado'},
    {   value: SituacaoFaturaTypes.SITUACAO_EM_PROCESSAMENTO, description: 'Em Processamento'},
    {   value: SituacaoFaturaTypes.PAGO_PARCIAL, description: 'Pago Parcial'}
]);

export const SituacaoOrigemList  = new enumDescription(  [
    {   value: TipoOrigem.GERADO_AUTOMATICAMENTE, description: 'Automático'},
    {   value: TipoOrigem.GERADO_MANUALMENTE, description: 'Manual'},
]);

export const SituacaoFaturaDocumentoList = new enumDescription(  [
    {   value: SituacaoFaturaDocumentoTypes.SITUACAO_PENDENTE, description: 'Pendente'},
    {   value: SituacaoFaturaDocumentoTypes.SITUACAO_SINCRONIZADO, description: 'Sincronizado'},
    {   value: SituacaoFaturaDocumentoTypes.SITUACAO_CANCELADO, description: 'Cancelado'},
    {   value: SituacaoFaturaDocumentoTypes.SITUACAO_PRONTO_ENVIO, description: 'Pronto Para Envio'},
    {   value: SituacaoFaturaDocumentoTypes.SITUACAO_LIQUIDADO, description: 'Pago e Enviado'},

]);

export const TipoFaturaDocumentoList = new enumDescription(  [
    {   value: TipoFaturaDocTypes.NOTA_FISCAL, description: 'Nota Fiscal'},
    {   value: TipoFaturaDocTypes.BOLETO, description: 'Boleto'},
]);

export const MesList = new enumDescription(  [
    {   value: 1, description: 'Janeiro'},
    {   value: 2, description: 'Fevereiro'},
    {   value: 3, description: 'Março'},
    {   value: 4, description: 'Abril'},
    {   value: 5, description: 'Maio'},
    {   value: 6, description: 'Junho'},
    {   value: 7, description: 'Julho'},
    {   value: 8, description: 'Agosto'},
    {   value: 9, description: 'Setembro'},
    {   value: 10, description: 'Outubro'},
    {   value: 11, description: 'Novembro'},
    {   value: 12, description: 'Dezembro'}
]);

export const mesListFormater  = (params:any) =>{
    return MesList.getDescription(params.value);
}

export const situacaoListFormater = (params:any) =>{
    return SituacaoList.getDescription(params.value);
}

export const situacaoFaturaListFormater = (params:any) =>{
    return SituacaoFaturaList.getDescription(params.value);
}

export const situacaoOrigemListFormater = (params:any) =>{
    return SituacaoOrigemList.getDescription(params.value);
}

export const SituacaoFaturaDocumento = (params:any) =>{
    return SituacaoFaturaDocumentoList.getDescription(params.value);
}

export const TipoFaturaDocumento = (params:any) =>{
    return TipoFaturaDocumentoList.getDescription(params.value);
}

export default routes;